import { IJSLComponent, IJSLVNode, refresh } from "jsl-render";
import { FormFieldComponent } from "jsl-ui";
import { DropDownComponent } from "jsl-ui/lib/components/drop-down/DropDownComponent";

export class CopyrightComponent implements IJSLComponent {

    private copyrightInfo: FormFieldComponent;
    private copyRightDD: DropDownComponent;

    public constructor() {
        this.copyRightDD = new DropDownComponent({
            data: [
                {
                    value: "Creative Commons (CC BY-NC-SA 4.0)",
                    text: "Creative Commons (CC BY-NC-SA 4.0)"
                },
                {
                    value: "Creative Commons (CC:0)",
                    text: "Creative Commons (CC:0)"
                },
                {
                    value: "-",
                    text: "Andere"
                }],
            onChange: () => {
                refresh();
            },
            searchable: false
        });
        this.copyrightInfo = new FormFieldComponent({ type: "text", maxLength: 250, label: "Copyright Vermerk Bilder" });
    }

    public render(): IJSLVNode {
        return <div class="mb-10"><div>© Bilder</div>
            {this.copyRightDD}
            {this.copyRightDD.getRef()?.getValue() === "-" ? this.copyrightInfo : null}
        </div>;
    }

    public getValue(): string {
        let copyright = this.copyRightDD.getRef().getValue() as string;
        if (copyright === "-") {
            copyright = this.copyrightInfo.getValue();
        }
        return copyright;
    }

}
